import { IUser } from 'app/shared/model/user.model';

export interface IReferralCode {
  id?: number;
  referralCode?: string | null;
  user?: IUser | null;
}

export const defaultValue: Readonly<IReferralCode> = {};
